import { useEffect, useState } from 'react';
import axios from 'axios';
import { parsePricingCatalog, type PricingCatalog } from './Catalog';
import { useAuthWrapperContext } from 'Contexts/AuthWrapperContext';

export function usePricingCatalog(enabled = true, fixture?: PricingCatalog) {
  const { currentAuthToken } = useAuthWrapperContext();
  const [catalog, setCatalog] = useState<PricingCatalog | null>(fixture ?? null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(enabled && !fixture);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!enabled || fixture) return;
    let canceled = false;
    setLoading(true);
    setError(null);
    setCatalog(null);
    (async () => {
      try {
        const token = await currentAuthToken();
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/stripe/pricing`,
          {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 15000,
          },
        );
        const result = parsePricingCatalog(response.data);
        if (!canceled) setCatalog(result);
      } catch {
        if (!canceled) setError('Subscription pricing is unavailable. Please try again.');
      } finally {
        if (!canceled) setLoading(false);
      }
    })();
    return () => {
      canceled = true;
    };
  }, [enabled, fixture, currentAuthToken, revision]);
  return { catalog, error, loading, reload: () => setRevision((value) => value + 1) };
}
